import ShiftViewPage from './ShiftViewPage';

export default ShiftViewPage;
